<div class="ui-radio"
  :class="[{'style--has-text': text != ''}, 'style--'+layout, state.errorStyle, state.disableStyle]">
  <input :name="name" :id="state.id" type="radio" v-model="privateSelected" :value="value" 
  @click="onClickRadio(value)" @change="onChange(value)" >
  <label :for="state.id" class="checkbox-style-block" 
  @keypress.enter="onClickKeypress(value)" :tabindex="isDisable ? -1 : 0" >
    <span class="checkmark-block">
      <span class="checkmark">
      </span>
    </span>
    <span class="text" :style="{'paddingLeft': paddingLeft+'px'}">{{text}}</span>
  </label>
</div>